// biome-ignore lint/complexity/noUselessEscapeInRegex: porting the ignore from eslint-disable-next-line
const EMAIL_REGEX = /^[a-zA-Z0-9_\.-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]{2,}$/g;

export const isValidEmail = (email: unknown): boolean =>
  typeof email === 'string' ? Boolean(email.match(EMAIL_REGEX)) : false;
